import React from "react";
import PropTypes from "prop-types";

export default (WrappedComponent) => {
  const hocComponent = ({ ...props }) => {
    if (!props.open) return null;
    return (
      <div id="overlay">
        <WrappedComponent {...props} />
      </div>
    );
  };

  hocComponent.propTypes = {};

  return hocComponent;
};
